import axios, { AxiosRequestConfig } from "axios";
import { IsAuthorized } from "src/authentication/IsAuthorized";
import { getJWT } from "src/helper/localStore/getJWT";

class AccounStateServices {
    async getReservations(page:number, limit:number, filter = {}, business_unit_id:string | null = null, work_unit_id:string | null = null, seller_filter:number | null = null): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{
                    page,
                    limit,
                    business_unit_id,
                    work_unit_id,
                    seller_filter,
                    ...filter
                }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getReserves`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getReservationsWithCredits(page:number, limit:number, filter = {}, business_unit_id:string | null = null, work_unit_id:string | null = null, seller_filter:number | null = null): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{
                    page,
                    limit,
                    business_unit_id,
                    work_unit_id,
                    seller_filter,
                    ...filter
                }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getReservesWithCredits`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getItems(reserve_id:number): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{
                    reserve_id
                }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/items`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getBalancesAmount(business_unit_id:string | null = null, work_unit_id:string | null = null, seller_filter:number | null = null): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{business_unit_id, work_unit_id, seller_filter}
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getBalancesAmount`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getBalancesPerWeek(dates:string, business_unit_id: string | null = null, work_unit_id:string | null = null, seller_filter:number | null = null): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{daysOfWeek:dates,business_unit_id, work_unit_id, seller_filter}
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getBalancesPerWeek`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getAmountPerPeriod(business_unit_id: string | null = null, work_unit_id:string | null = null, seller_filter:number | null = null): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{business_unit_id, work_unit_id, seller_filter}
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getAmountPerPeriod`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getDebtRanking(): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getDebtRanking`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async getLastUpdateInfo(): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/account-state/getLastUpdateInfo`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }

    async exportReservations(filter={},has_credit = null, business_unit_id:string | null = null, work_unit_id:string | null = null, seller_filter:string | null = null, with_tma:boolean = false): Promise<any> {
        try {
            const config: AxiosRequestConfig = {
                headers: { 'authentication-token': getJWT()! },
                params:{
                    business_unit_id,
                    work_unit_id,
                    has_credit,
                    seller_filter,
                    with_tma,
                    ...filter
                }
            }
            const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/account-state/export-xlsx/`, config)
            return res.data
        } catch (error) {
            IsAuthorized(error)
            throw error
        }
    }
}

export const accountStateServices = new AccounStateServices()